<template>
	<div>
	<div class="main">
		<div class="box lottery">
			<Header ref="header"></Header>
			<GameBanner :src="gameData.topBgImage" :variant="gameData.extraFields.bannerType"
				:drawProductId="gameData.extraFields.bannerDrawProductId" />
			<div class="item_Options">
				<div class="content">
					<UserInfo ref="userInfo"></UserInfo>
					<div class="position">
						<div class="lottery-ui">
							<div class="lottery-stage">
								<button class="rule-open-btn" @click="showRulePopup = true" :aria-label="$t('lottery_rule_button')">{{ $t('lottery_rule_button') }}</button>
								<div class="points-bar">
									<div class="points-main-line">
										<span v-if="activityType == 1" class="copywriting-text copywriting-1">{{ $t('lottery_current_points_label') }}</span>
										<span class="points-label">{{ amountLabel }}</span>
										<span class="points-value">{{ amountValue }}</span>
									</div>
									<span v-if="activityType == 1" class="copywriting-text copywriting-2">{{ $t('lottery_points_recharge_tip') }}</span>
								</div>
								<div class="center-stage">
									<div class="wheel-wrap">
										<div class="wheel-pointer">
											<img class="wheel-pointer-image" :src="pointerUrl" :style="pointerStyle"
												alt="pointer">
											<!-- <span class="pointer-origin-marker" :style="pointerStyle"></span> -->
											<img class="lottery-text-image" src="./pointer-2.png" alt="">
											<span class="lottery-text-label">{{ $t('lottery_spin_label') }}</span>
										</div>
										<div class="wheel-ring" :style="wheelBackgroundStyle"></div>
										<div v-for="(segment, index) in wheelSegments" :key="segment.id || index"
											class="wheel-prize" :style="getPrizeItemStyle(index)">
											<img class="wheel-prize-image" :src="segment.image" :alt="segment.label">

										</div>
									</div>
									<div class="action-row">
										<button class="draw-btn draw-btn-limit" :class="{ 'is-loading': isDrawing }" @click="tryDraw" :aria-label="drawButtonText">{{ drawButtonText }}</button>
										<button class="record-btn" @click="openRecord" :aria-label="$t('lottery_record_button')">{{ $t('lottery_record_button') }}</button>
									</div>
								</div>

								
							</div>
						</div>
						<div class="lottery-init-mask" v-if="isInitDataLoading">
							<div class="lottery-init-loading"></div>
						</div>
					</div>
				</div>
			</div>
			<Footer></Footer>
		</div>
	</div>

	<LotteryPrizePopup :visible="showPrizePopup" @close="showPrizePopup = false">
		<div class="lottery-prize-result" v-if="prizeResultName">
			<p class="lottery-prize-name">{{ prizeResultName }}</p>
			<p class="lottery-prize-tip">{{ $t('claim_success_text') }}</p>
		</div>
		<div class="lottery-popup-tip" v-else>
			<p class="lottery-tip-text">{{ popupTip }}</p>
		</div>
	</LotteryPrizePopup>

	<LotteryPrizePopup :visible="showRecordPopup" @close="showRecordPopup = false">
		<div class="lottery-record">
			<div class="lottery-record-title">{{ $t('lottery_record_title') }}</div>
			<div v-if="recordList.length === 0" class="lottery-record-empty">{{ $t('lottery_record_empty') }}</div>
			<div v-else class="lottery-record-scroll">
				<table class="lottery-record-table">
					<thead>
						<tr>
							<th>{{ $t('lottery_record_time') }}</th>
							<th>{{ $t('lottery_record_prize') }}</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(record, index) in recordList" :key="record.id || index">
							<td>{{ record.time }}</td>
							<td>{{ record.rewardName }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</LotteryPrizePopup>

	<transition name="rule-fade">
		<div class="lottery-rule-overlay" v-if="showRulePopup" @click.self="showRulePopup = false">
			<div class="lottery-rule-popup">
				<img class="lottery-rule-close" src="./closure.png" alt="" @click="showRulePopup = false">
				<div class="lottery-rule-title">
					<img class="lottery-rule-title-image" src="./Rule_box_title.png" alt="">
					<span class="lottery-rule-title-text">{{ $t('lottery_rule_popup_title') }}</span>
				</div>
				<div class="lottery-rule-body">
					<div class="lottery-rule-scroll">{{ ruleText }}</div>
				</div>
			</div>
		</div>
	</transition>
	</div>
</template>

<script>
import $ from 'jquery'
import Header from '../../components/header.vue'
import Footer from '../../components/footer.vue'
import UserInfo from '../../components/userInfo.vue'
import LotteryPrizePopup from './LotteryPrizePopup.vue'
import GameBanner from '../../components/GameBanner.vue'
import { isEmpty } from '../../utils/index.js'

export default {
	name: 'lotteryIndex',
	components: {
		Header,
		Footer,
		UserInfo,
		GameBanner,
		LotteryPrizePopup
	},
	data() {
		return {
			gameData: this.$store.state.gameData,
			activityType: 1,
			pointsBalance: 0,
			drawCost: 0,
			payAmount: 0,
			lotteryCount: 0,
			wheelBgUrl: 'https://cdn-download.luckyyx.com/image/cms/20260521/d98f134acfdf4f54a4fc06d1f02705a2.png',
			pointerUrl: 'https://cdn-download.dustyx.com/image/cms/20260526/4144f86392a24c3d9cbacf6220947909.png',
			roleInfo: this.$cache.getRoleInfo(),
			pointerRotation: 0,
			isSpinning: false,
			isDrawing: false,
			isInitDataLoading: false,
			showPrizePopup: false,
			showRecordPopup: false,
			showRulePopup: false,
			prizeResultName: '',
			popupTip: '',
			recordList: [],
			ruleText: '',
			prizeList: [
				
			]
		}
	},
	computed: {
		wheelSegments() {
			return Array.isArray(this.prizeList) ? this.prizeList : []
		},
		segmentAngle() {
			return this.wheelSegments.length > 0 ? 360 / this.wheelSegments.length : 360
		},
		wheelBackgroundStyle() {
			const url = this.wheelBgUrl || ''
			return {
				backgroundImage: url ? `url(${url})` : 'none'
			}
		},
		pointerStyle() {
			return {
				transform: `rotate(${this.pointerRotation}deg)`
			}
		},
		amountLabel() {
			return this.activityType === 2 ? '' : ''
		},
		amountValue() {
			return this.activityType === 2 ? '' : this.pointsBalance
		},
		drawButtonText() {
			if (this.drawCost === -1) {
				return this.$t('lottery_daily_limit')
			}
			if (this.activityType === 2) {
				return this.$t('lottery_remaining_count', { count: this.lotteryCount })
			}
			return this.$t('lottery_draw_cost', { cost: this.drawCost })
		},
		drawCostText() {
			return this.drawCost === -1 ? 0 : this.drawCost
		}
	},
	mounted() {
		this.initScoreActivityData();
		this.autoOpenRoleChooseWindow();
	},
	methods: {
		autoOpenRoleChooseWindow: function (retryCount = 0) {
			if (!this.$session.hasLogin() || !isEmpty(this.$cache.getRoleInfo())) {
				return;
			}
			this.$nextTick(() => {
				if (this.$refs.userInfo && $.fn.bPopup && document.getElementById('roleChooseWindow')) {
					this.$refs.userInfo.openRoleChooseWindow();
					return;
				}
				if (retryCount < 10) {
					setTimeout(() => {
						this.autoOpenRoleChooseWindow(retryCount + 1);
					}, 200);
				}
			});
		},
		// Initialize score lottery data and normalize prize items for wheel display.
		initScoreActivityData: async function () {
			this.isInitDataLoading = true;
			try {
				const response = await this.$axios({
					method: 'get',
					url: '/web/api/scoreActivity/init-data',
					params: {
						userId: this.$session.getUserId(),
						gameCode: this.$cache.getGameCode(),
						gameLanguage: this.getGameLanguage()
					}
				});
				if (response.code !== 1000 || !response.data) {
					return;
				}

				const data = response.data;
				this.activityType = data.activityType || 1;
				if (Array.isArray(data.prize) && data.prize.length > 0) {
					this.prizeList = data.prize.map((item, index) => {
						return {
							id: item.id || index + 1,
							label: item.name || `prize${index + 1}`,
							image: item.icon
						}
					}).filter(item => item.image);
				}
				if (typeof data.balancePoints === 'number') {
					this.pointsBalance = data.balancePoints;
				}
				if (typeof data.currentLotteryPoints === 'number') {
					this.drawCost = data.currentLotteryPoints;
				}
				if (typeof data.payAmount === 'number') {
					this.payAmount = data.payAmount;
				}
				if (typeof data.lotteryCount === 'number') {
					this.lotteryCount = data.lotteryCount;
				}
				if (typeof data.ruleText === 'string') {
					this.ruleText = data.ruleText;
				}
			} catch (error) {
				console.error(this.$t('lottery_init_data_error'), error);
			} finally {
				this.isInitDataLoading = false;
			}
		},
		getPrizeItemStyle(index) {
			const angle = this.segmentAngle * index + this.segmentAngle / 2
			const radius = this.wheelSegments.length >= 6 ? 1.5 : 1.38
			return {
				transform: `translate(-50%, -50%) rotate(${angle}deg) translateY(-${radius}rem) rotate(${-angle}deg)`
			}
		},
		async tryDraw() {
			if (!this.$session.hasLogin()) {
				$("#loginWindow").bPopup();
				return
			}
			const roleInfo = this.$cache.getRoleInfo()
			if (isEmpty(roleInfo) || isEmpty(roleInfo.roleId) || isEmpty(roleInfo.serverCode)) {
				this.$refs.userInfo.openRoleChooseWindow();
				return
			}
			if (this.isSpinning || this.isDrawing) return
			if (this.drawCost === -1) {
				this.prizeResultName = ''
				this.popupTip = this.$t('lottery_daily_limit')
				this.showPrizePopup = true
				return
			}
			if (this.activityType === 2) {
				if (this.lotteryCount <= 0) {
					this.prizeResultName = ''
					this.popupTip = this.$t('insufficient_lottery_count_text')
					this.showPrizePopup = true
					return
				}
			} else {
				if (this.pointsBalance < this.drawCost) {
					this.prizeResultName = ''
					this.popupTip = this.$t('insufficient_points_text')
					this.showPrizePopup = true
					return
				}
			}

			let response
			try {
				this.isDrawing = true
				response = await this.$axios({
					method: 'get',
					url: '/web/api/scoreActivity/lottery',
					params: {
						userId: this.$session.getUserId(),
						gameCode: this.$cache.getGameCode(),
						gameLanguage: this.getGameLanguage(),
						roleId: roleInfo.roleId,
						serverCode: roleInfo.serverCode
					}
				})
			} catch (e) {
				// Network errors already handled by axios interceptor
				this.isDrawing = false
				return
			}
			this.isDrawing = false

			if (!response.successful || response.code !== 1000) {
				this.prizeResultName = ''
				this.popupTip = response.message || 'Error'
				this.showPrizePopup = true
				return
			}

			const prizeData = response.data
			const prizeIndex = this.prizeList.findIndex(p => String(p.id) === String(prizeData.id))

			if (this.activityType === 2) {
				this.lotteryCount -= 1
			} else {
				this.pointsBalance -= this.drawCost
			}

			this.prizeResultName = prizeData.name
			this.startSpinToIndex(prizeIndex >= 0 ? prizeIndex : 0)

			setTimeout(() => {
				this.showPrizePopup = true
				this.initScoreActivityData()
			}, 2500)
		},
		async openRecord() {
			if (!this.$session.hasLogin()) {
				$("#loginWindow").bPopup();
				return
			}
			const roleInfo = this.$cache.getRoleInfo()
			if (isEmpty(roleInfo) || isEmpty(roleInfo.roleId) || isEmpty(roleInfo.serverCode)) {
				this.$refs.userInfo.openRoleChooseWindow();
				return
			}
			await this.getLotteryRecords()
			this.showRecordPopup = true
		},
		async getLotteryRecords() {
			try {
				const response = await this.$axios({
					method: 'get',
					url: '/web/api/scoreActivity/lottery-record',
					params: {
						userId: this.$session.getUserId(),
						gameCode: this.$cache.getGameCode(),
						gameLanguage: this.getGameLanguage()
					}
				})
				if (response.code !== 1000 || !response.data) {
					this.recordList = []
					return
				}

				const records = Array.isArray(response.data) ? response.data : (response.data.records || response.data.list || [])
				this.recordList = records.map(item => {
					return {
						id: item.id,
						time: item.date || '',
						rewardName: item.name || ''
					}
				})
			} catch (e) {
				this.recordList = []
			}
		},
		getGameLanguage() {
			return (this.gameData && this.gameData.language) || (this.$i18n && this.$i18n.locale) || 'en_US'
		},
		startSpinToIndex(index) {
			this.isSpinning = true
			const targetVisualAngle = this.segmentAngle * index + this.segmentAngle / 2
			const currentBase = Math.floor(this.pointerRotation / 360) * 360
			this.pointerRotation = currentBase + 1080 + targetVisualAngle
			setTimeout(() => {
				this.isSpinning = false
			}, 2400)
		}
	}
}
</script>

<style>
.lottery .item_Options {
	min-height: 12.6375rem;
}

.lottery .item_Options .content {
	min-height: 0rem;
}

.lottery .item_Options .content .position {
	position: relative;
	width: 15rem;
	padding: 0rem;
	height: 8.8rem;
}

.position .lottery-ui {
	width: 100%;
	height: 100%;
	position: relative;
	background: #efefef url('./bj.png') 0% top / auto 100% no-repeat;
	border: 1px solid #d9d9d9;
	border-radius: .1rem;
	color: #222;
	overflow: hidden;
}

.lottery-stage {
	width: 100%;
	height: 100%;
	display: flex;
	position: relative;
	flex-direction: column;
	align-items: stretch;
	padding: .18rem .2rem .28rem;
	box-sizing: border-box;
}

.lottery-init-mask {
	position: absolute;
	inset: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	background: #fff;
	border-radius: .1rem;
	z-index: 20;
}

.lottery-init-loading {
	width: .72rem;
	height: .72rem;
	border-radius: 50%;
	border: .08rem solid rgba(76, 36, 31, .18);
	border-top-color: #4C241F;
	box-shadow: 0 0 .18rem rgba(76, 36, 31, .28);
	animation: lotteryInitLoading 0.8s linear infinite;
}

@keyframes lotteryInitLoading {
	to {
		transform: rotate(360deg);
	}
}

.rule-open-btn {
	position: absolute;
	top: .3rem;
	right: .32rem;
	min-width: 1.54rem;
	height: .5rem;
	padding: 0 .12rem;
	border: none;
	background: transparent;
	cursor: pointer;
	z-index: 6;
	font-size: .26rem;
	font-weight: 700;
	color: #DDC5AC;
	text-shadow:
		0 .02rem 0 #4C241F,
		.02rem 0 0 #4C241F,
		-.02rem 0 0 #4C241F,
		0 -.02rem 0 #4C241F,
		0 .03rem .04rem rgba(45, 18, 0, .65);
	white-space: nowrap;
}

.rule-open-btn::before {
	content: '○';
	display: inline-block;
	font-size: 1.8em;
	line-height: 1;
	margin-right: .04rem;
	vertical-align: middle;
	transform: translateY(-.03rem);
}

.rule-open-btn:hover {
	opacity: .92;
}

.points-bar {
	width: 100%;
	font-size: .4rem;
	font-weight: 700;
	color: #6e4a35;
	text-align: left;
	padding-top: 0.35rem;
    padding-left: 1.2rem;
}

.points-main-line {
	display: flex;
	align-items: center;
	gap: .1rem;
}

.copywriting {
	display: block;
	height: auto;
	object-fit: contain;
}

.copywriting-text {
	display: inline-block;
	flex: 0 0 auto;
	line-height: 1;
}

.copywriting-1 {
	flex: 0 0 auto;
}

.copywriting-2 {
	display: block;
	margin-top: .12rem;
	color: #B27E60;
}

.center-stage {
	flex: 1;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	/* padding-bottom: 2rem; */
	box-sizing: border-box;
}

.wheel-wrap {
	position: relative;
	width: 4.6rem;
	height: 4.6rem;
	margin-left: auto;
	margin-right: auto;
}

.wheel-pointer {
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	z-index: 4;
}

.wheel-pointer-image {
	display: block;
	width: 2.45rem;
	height: auto;
	filter: drop-shadow(0 .02rem .04rem rgba(0, 0, 0, .2));
	transform-origin: 50% 60%;
	transition: transform 2.4s cubic-bezier(.18, .84, .2, 1);
}

.pointer-origin-marker {
	position: absolute;
	left: 50%;
	top: 60%;
	width: .14rem;
	height: .14rem;
	margin-left: -.07rem;
	margin-top: -.07rem;
	border-radius: 50%;
	background: #ff1f1f;
	border: .02rem solid #fff;
	box-shadow: 0 0 .08rem rgba(0, 0, 0, .45);
	transform-origin: 50% 50%;
	transition: transform 2.4s cubic-bezier(.18, .84, .2, 1);
	z-index: 5;
	pointer-events: none;
}

.lottery-text-image {
	position: absolute;
	left: 50%;
	top: 50%;
	width: 100%;
	height: auto;
	transform: translate(-50%, -50%);
	z-index: 2;
	pointer-events: none;
}

.lottery-text-label {
	position: absolute;
	left: 50%;
	top: 60%;
	z-index: 3;
	transform: translate(-50%, -50%);
	color: #fff;
	font-size: .2rem;
	font-weight: 700;
	line-height: 1;
	white-space: nowrap;
	text-shadow: 0 .02rem .04rem rgba(91, 38, 0, .65);
	pointer-events: none;
}

.wheel-ring {
	position: absolute;
	inset: 0;
	border-radius: 50%;
	background-color: #f6f6f6;
	background-repeat: no-repeat;
	background-position: center center;
	background-size: contain;
	border: none;
}

.wheel-ring::before {
	content: '';
	position: absolute;
	inset: 0;
	border-radius: 50%;
	border: none;
	box-shadow: none;
}

.wheel-prize {
	position: absolute;
	left: 50%;
	top: 50%;
	width: 1.15rem;
	text-align: center;
	transform-origin: center center;
	z-index: 2;
}

.wheel-prize-image {
	display: block;
	width: 1rem;
	height: 1rem;
	object-fit: contain;
	margin: 0 auto;
	filter: drop-shadow(0 .03rem .06rem rgba(0, 0, 0, .18));
}

.wheel-prize-count {
	margin-top: .02rem;
	font-size: .2rem;
	font-weight: 700;
	line-height: 1;
	color: #ffe9a6;
	text-shadow: 0 1px 3px rgba(62, 16, 7, .8);
}



.action-row {
	margin-top: .32rem;
	display: flex;
	gap: .18rem;
	flex-wrap: wrap;
	justify-content: center;
	width: 100%;
}

.position .lottery-ui .draw-btn,
.position .lottery-ui .record-btn {
	min-width: 2rem;
	height: .52rem;
	padding: 0 .32rem;
	background: #1e9bf0;
	color: #fff;
	border: none;
	border-radius: .26rem;
	font-size: .22rem;
	font-weight: 700;
	cursor: pointer;
	box-shadow: none;
	transition: opacity .12s ease;
}

.position .lottery-ui .record-btn {
	width: 2.4rem;
	min-width: 2.4rem;
	height: .82rem;
	padding: 0 0 .05rem .4rem;
	background: transparent url('./Button-2.png') center center / contain no-repeat;
	border-radius: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: .24rem;
	font-weight: 700;
	color: #7a3319;
	text-shadow: 0 .02rem .04rem rgba(91, 38, 0, .45);
}

.position .lottery-ui .draw-btn {
	width: 2.4rem;
	min-width: 2.4rem;
	height: .82rem;
	padding: 0 0 .05rem .25rem;
	background: transparent url('./Button-1.png') center center / contain no-repeat;
	border-radius: 0;
	font-size: .22rem;
	color: #fff;
	text-shadow: 0 .02rem .04rem rgba(91, 38, 0, .45);
	position: relative;
	overflow: hidden;
}

.position .lottery-ui .draw-btn.draw-btn-limit {
	padding: 0 0 .04rem .5rem;
}

.position .lottery-ui .draw-btn.is-loading {
	pointer-events: none;
	opacity: .82;
	color: transparent;
	text-shadow: none;
}

.position .lottery-ui .draw-btn.is-loading::after {
	content: '';
	position: absolute;
	left: 50%;
	top: 50%;
	width: .34rem;
	height: .34rem;
	margin-left: -.17rem;
	margin-top: -.17rem;
	border: .045rem solid rgba(255, 255, 255, .42);
	border-top-color: #fff;
	border-radius: 50%;
	animation: lotteryDrawLoading .8s linear infinite;
	box-shadow: 0 0 .12rem rgba(255, 255, 255, .35);
}

@keyframes lotteryDrawLoading {
	to {
		transform: rotate(360deg);
	}
}

.position .lottery-ui .draw-btn:hover,
.position .lottery-ui .record-btn:hover {
	transform: none;
	box-shadow: none;
	opacity: .92;
}

.rule-panel {
	position: absolute;
	left: 50%;
	bottom: .04rem;
	width: 90%;
	margin-top: 0;
	padding: .38rem .5rem .7rem;
	box-sizing: border-box;
	background: transparent url('./Rule_box.png') center center / 100% 100% no-repeat;
	border: none;
	border-radius: 0;
	box-shadow: none;
	transform: translateX(-50%);
}

.rule-title {
	font-size: .3rem;
	font-weight: 700;
	color: #333;
	margin-bottom: .08rem;
}

.rule-line {
	font-size: .2rem;
	line-height: 1.7;
	color: #666;
}

@media (max-width: 768px) {
	.box {
		min-height: 22.5rem;
	}

	.lottery .item_Options .content .position {
		width: 10rem;
		min-height: 11.4rem;
	}

	.center-stage {
		padding-bottom: 2.5rem;
	}

	.wheel-wrap {
		width: 5rem;
		height: 5rem;
	}

	.wheel-pointer {
		top: 50%;
	}

	.wheel-pointer-image {
		width: 1.32rem;
	}

	.lottery-text-image {
		width: .7rem;
	}

	.pointer-origin-marker {
		width: .1rem;
		height: .1rem;
		margin-left: -.05rem;
		margin-top: -.05rem;
	}

	.wheel-prize-image {
		width: 1.1rem;
		height: 1.1rem;
	}

	.wheel-prize-count {
		font-size: .24rem;
	}

	.rule-line {
		font-size: .32rem;
	}

	.points-bar {
		font-size: .4rem;
		padding-top: 0.6rem;
		padding-left: 1.5rem;
	}

	.rule-title {
		font-size: .36rem;
	}

	.rule-panel {
		left: 50%;
		bottom: .08rem;
		width: 90%;
		padding: .46rem .58rem .38rem;
	}

	.position .lottery-ui .draw-btn,
	.position .lottery-ui .record-btn {
		min-width: 2.8rem;
		height: .76rem;
		font-size: .34rem;
	}

	.position .lottery-ui .draw-btn {
		width: 3.2rem;
		min-width: 3.2rem;
		height: 1.08rem;
		font-size: .34rem;
		padding-left: .3rem;
	}

	.position .lottery-ui .record-btn {
		width: 3.2rem;
		min-width: 3.2rem;
		height: 1.08rem;
		padding-left: .45rem;
		font-size: .32rem;
	}
}

.lottery-prize-result {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}

.lottery-prize-name {
	font-size: .32rem;
	font-weight: 700;
	color: #000000;
	margin: 0 0 .12rem;
	line-height: 1.4;
}

.lottery-prize-tip {
	font-size: .26rem;
	color: #000000;
	margin: 0;
}

.lottery-popup-tip {
	display: flex;
	align-items: center;
	justify-content: center;
	padding: .1rem 0;
}

.lottery-tip-text {
	font-size: .28rem;
	color: #000000;
	margin: 0;
	text-align: center;
	line-height: 1.6;
}

.lottery-record {
	width: 5.8rem;
	max-width: 80vw;
	color: #000000;
}

.lottery-record-title {
	font-size: .32rem;
	font-weight: 700;
	text-align: center;
	margin-bottom: .2rem;
}

.lottery-record-empty {
	font-size: .26rem;
	text-align: center;
	padding: .3rem 0;
}

.lottery-record-scroll {
	max-height: 4.2rem;
	overflow-y: auto;
}

.lottery-record-table {
	width: 100%;
	border-collapse: collapse;
	font-size: .22rem;
	line-height: 1.4;
}

.lottery-record-table th,
.lottery-record-table td {
	padding: .12rem .08rem;
	border-bottom: 1px solid rgba(255, 255, 255, .25);
	text-align: left;
	word-break: break-word;
}

.lottery-record-table th {
	font-weight: 700;
	color: #000000;
}

.lottery-rule-overlay {
	position: fixed;
	inset: 0;
	background: rgba(0, 0, 0, .6);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 9999;
}

.lottery-rule-popup {
	position: relative;
	width: auto;
	max-width: 88vw;
	display: flex;
	flex-direction: column;
	align-items: stretch;
}

.lottery-rule-close {
	position: absolute;
	top: -.12rem;
	right: -.18rem;
	width: .5rem;
	height: .5rem;
	cursor: pointer;
	z-index: 3;
}

.lottery-rule-title {
	position: relative;
	display: block;
	width: auto;
	max-width: 88vw;
	height: auto;
}

.lottery-rule-title-image {
	display: block;
	width: 100%;
	height: auto;
}

.lottery-rule-title-text {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	color: #7a3319;
	font-size: .34rem;
	font-weight: 700;
	line-height: 1;
	white-space: nowrap;
	text-align: center;
}

.lottery-rule-body {
	width: 100%;
	min-height: 2.6rem;
	margin-top: -.02rem;
	padding: .34rem .62rem .58rem;
	box-sizing: border-box;
	background: transparent url('./Rule_box_text.png') center top / 100% 100% no-repeat;
}

.lottery-rule-scroll {
	width: 100%;
	max-height: 8.8rem;
	overflow-y: auto;
	padding-right: .08rem;
	box-sizing: border-box;
	color: #6b3f1d;
	font-size: .23rem;
	line-height: 1.7;
	text-align: left;
	white-space: pre-line;
	word-break: break-word;
}

.lottery-rule-scroll::-webkit-scrollbar {
	width: .08rem;
}

.lottery-rule-scroll::-webkit-scrollbar-thumb {
	border-radius: .08rem;
	background: rgba(126, 76, 34, .45);
}

.rule-fade-enter-active,
.rule-fade-leave-active {
	transition: opacity .2s ease;
}

.rule-fade-enter,
.rule-fade-leave-to {
	opacity: 0;
}
</style>
